import React, { useMemo } from 'react'
import T from 'prop-types'
import getPictures from 'lib/getCarPictures'

import CarDetails from '../CarDetails'
import CarDetailsPageTitle from '../CarDetails/CarDetailsPageTitle'
import CarBookedCarAdditionalDetails from '../CarsBooked/CarBookedCarAdditionalDetails'

export default function CarsBookedCarDetails({
  plate,
  session,
  cars,
  setShowDetails,
  showFavorites = false,
  showPriceRange = true,
}) {
  const car = useMemo(
    () => cars.find((car) => car.plate === plate),
    [cars, plate]
  )

  const pictures = useMemo(
    () => getPictures(car?.pictureurl),
    [car?.pictureurl]
  )

  return (
    <div data-testid="cars-booked-details">
      <CarDetailsPageTitle
        setShowDetails={setShowDetails}
        cars={cars}
        plate={plate}
      />
      {car && (
        <CarDetails
          car={car}
          price={car.price}
          maxPrice={car.maxPrice}
          showPriceRange={showPriceRange}
          pictures={pictures}
          showFavoriteReadOnly={showFavorites}
          rightBottom={
            <CarBookedCarAdditionalDetails
              vertical
              car={car}
              canReprice={session?.canReprice}
            />
          }
        />
      )}
    </div>
  )
}

CarsBookedCarDetails.propTypes = {
  plate: T.string.isRequired,
  session: T.object.isRequired,
  cars: T.array.isRequired,
  showPriceRange: T.bool,
}
